export var Edit_Application_Helper = {
    makeRegistation: (toast, application, type = "registration") => {
        const entity = application.registration; // always from registration
        var applicationObject = {
            "applicationID": application.applicationID,
            "idNumber": application.idNumber,
            "name": entity?.name || '',
            "middlename": entity?.middlename || '',
            "surname": entity?.surname || '',
            "dateOfBirth": new Date(entity?.dateOfBirth)?.toIsoString() || '',
            "cellPhone1": entity?.cellPhone1?.number || null,
            "cellPhone2": entity?.cellPhone2?.number || null,
            "cellPhone1CountryCodeID": entity?.cellPhone1?.countryCodeID || null,
            "cellPhone2CountryCodeID": entity?.cellPhone2?.countryCodeID || null,
            "email": entity?.email || null,
            "genderID": entity?.genderID || null,
            "disabilityID": entity?.disabilityID,
            "villageID": application?.village?.villageID,
            "binaryData": application.fileUploaderDocuments
        };

        // --- Validations ---
        if (!applicationObject.idNumber) {
            toast.show({ severity: "error", detail: 'id number is required', life: 2500 });
            return { success: false, form: applicationObject };
        }
        if (applicationObject.idNumber.trim().length !== 12) {
            toast.show({ severity: "error", detail: 'id number length must be 12', life: 2500 });
            return { success: false, form: applicationObject };
        }
        if (!applicationObject.name.trim()) {
            toast.show({ severity: "error", detail: 'name is required', life: 2500 });
            return { success: false, form: applicationObject };
        }
        if (!applicationObject.surname.trim()) {
            toast.show({ severity: "error", detail: 'surname is required', life: 2500 });
            return { success: false, form: applicationObject };
        }
        if (!applicationObject.dateOfBirth.trim()) {
            toast.show({ severity: "error", detail: 'date of birth is required', life: 2500 });
            return { success: false, form: applicationObject };
        }
        if (!applicationObject.villageID) {
            toast.show({ severity: "error", detail: 'village is required', life: 2500 });
            return { success: false, form: applicationObject };
        }
        if (!applicationObject.cellPhone1) {
            toast.show({ severity: "error", detail: 'cellphone 1 is required', life: 2500 });
            return { success: false, form: applicationObject };
        }

        return { success: true, form: applicationObject };
    },

    makeAmendment: (application, type = "amendment") => {
        const entity = application.amendment;
        console.log(entity)
        var applicationObject = {
            "applicationID": application.applicationID,
            "idNumber": application.idNumber,
            "name": entity?.name || '',
            "middlename": entity?.middlename || '',
            "surname": entity?.surname || '',
            "dateOfBirth": entity?.dateOfBirth,
            "cellPhone1": entity?.cellPhone1?.number || null,
            "cellPhone2": entity?.cellPhone2?.number || null,
            "cellPhone1CountryCodeID": entity?.cellPhone1?.countryCodeID || null,
            "cellPhone2CountryCodeID": entity?.cellPhone2?.countryCodeID || null,
            "email": entity?.email || null,
            "genderID": entity?.genderID || null,
            "disabilityID": entity?.disabilityID,
            "villageID": application?.village?.villageID,
            "binaryData": application.fileUploaderDocuments
        };

        return { success: true, form: applicationObject };
    },
       makeCorrection: (application, type = "correction") => {
        const entity = application.amendment;
        var applicationObject = {
            "applicationID": application.applicationID,
            "idNumber": application.idNumber,
            "name": entity?.name || '',
            "middlename": entity?.middlename || '',
            "surname": entity?.surname || '',
            "dateOfBirth": new Date(entity?.dateOfBirth)?.toIsoString() || '',
            "cellPhone1": entity?.cellPhone1?.number || null,
            "cellPhone2": entity?.cellPhone2?.number || null,
            "cellPhone1CountryCodeID": entity?.cellPhone1?.countryCodeID || null,
            "cellPhone2CountryCodeID": entity?.cellPhone2?.countryCodeID || null,
            "email": entity?.email || null,
            "genderID": entity?.genderID || null,
            "disabilityID": entity?.disabilityID,
            "villageID": application?.village?.villageID,
            "binaryData": application.fileUploaderDocuments
        };

        return { success: true, form: applicationObject };
    }
};
